// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.internalPaneContent {
  background-color: #ddddff;
  padding: var(--spacing-xs, 0.5em);
  border-radius: 1rem;
}

.internalPaneControls {
  width: 100%;
  margin: var(--spacing-sm, 1em);
}

.internalPaneDeleteButton {
  height: var(--icon-base, 2em);
}
`, "",{"version":3,"sources":["webpack://./src/internal/internalPane.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;AAC/B","sourcesContent":[".internalPaneContent {\n  background-color: #ddddff;\n  padding: var(--spacing-xs, 0.5em);\n  border-radius: 1rem;\n}\n\n.internalPaneControls {\n  width: 100%;\n  margin: var(--spacing-sm, 1em);\n}\n\n.internalPaneDeleteButton {\n  height: var(--icon-base, 2em);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
